import PanelFarmDetails from "./PanelFarmDetails";

export default PanelFarmDetails;
